"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _EventHandler = require("../utils/EventHandler");

var _EventHandler2 = _interopRequireDefault(_EventHandler);

var _getCookie = require("../utils/getCookie");

var _getCookie2 = _interopRequireDefault(_getCookie);

var _setCookie = require("../utils/setCookie");

var _setCookie2 = _interopRequireDefault(_setCookie);

var _ScrollLock = require("../utils/ScrollLock");

var _ScrollLock2 = _interopRequireDefault(_ScrollLock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticExitIntent = function () {
  function StaticExitIntent(section) {
    (0, _classCallCheck3.default)(this, StaticExitIntent);

    this.el = section.el;
    this.data = section.data;
    this.ev = new _EventHandler2.default();

    this.productAtc = document.querySelector('.section-product [data-product-submit]');
    this.popup = this.el.querySelector('.exit-intent-popup');
    this.timeouts = [];

    if (!this.popup || !this.productAtc || (0, _getCookie2.default)('exitIntentShown')) {
      return;
    }

    this.addExitEventHandlers = this.addExitEventHandlers.bind(this);
    this.showExitIntentPopup = this.showExitIntentPopup.bind(this);
    this.exitIntentMouseEvent = this.exitIntentMouseEvent.bind(this);
    this.closePopupEvent = this.closePopupEvent.bind(this);

    this.ev.register(this.productAtc, 'click', this.addExitEventHandlers);
  }

  (0, _createClass3.default)(StaticExitIntent, [{
    key: "showExitIntentPopup",
    value: function showExitIntentPopup() {
      var _this = this;

      if ((0, _getCookie2.default)('exitIntentShown')) {
        return;
      }

      this.io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (entry.isIntersecting) {
          console.log('Impression', new Date());
          window.heap && window.heap.track('ExitIntentImpression', { productHandle: _this.data.productHandle, productVendor: _this.data.productVendor });
          _this.io.disconnect();
        }
      }, {
        threshold: 1.0
      });

      this.io.observe(this.popup);

      this.ev.register(document, 'keydown', this.closePopupEvent);
      this.ev.register(this.popup, 'click', this.closePopupEvent);

      this.popup.classList.add('show');
      this.popup.scrollTop;
      this.popup.classList.add('visible');
      _ScrollLock2.default.lock(this.popup);

      this.ev.register(this.el.querySelector('.call-to-action'), 'click', function () {
        window.heap && window.heap.track('ExitIntentClick', { productHandle: _this.data.productHandle, productVendor: _this.data.productVendor });
      });

      (0, _setCookie2.default)('exitIntentShown', true, this.data.showAgainDays);
    }
  }, {
    key: "exitIntentMouseEvent",
    value: function exitIntentMouseEvent(e) {
      var _this2 = this;

      var shouldShowExitIntent = !e.toElement && !e.relatedTarget && e.clientY < 10;

      if (shouldShowExitIntent) {
        this.ev.unregister(document, 'mouseout', this.exitIntentMouseEvent);

        this.timeouts.push(setTimeout(function () {
          _this2.showExitIntentPopup();
        }, this.data.delayTime * 1000));
      }
    }
  }, {
    key: "closePopupEvent",
    value: function closePopupEvent(e) {
      var shouldExit = [].concat((0, _toConsumableArray3.default)(e.target.classList)).includes('exit-intent-popup') || e.target.classList.contains('close') || e.target.closest('.close') || e.keyCode === 27;

      if (shouldExit) {
        _ScrollLock2.default.unlockAll();
        this.popup.classList.remove('show');
        this.popup.classList.remove('visible');
      }
    }
  }, {
    key: "addExitEventHandlers",
    value: function addExitEventHandlers() {
      var _this3 = this;

      this.ev.register(document, 'mouseout', this.exitIntentMouseEvent);
      this.ev.register(window, 'visibilitychange', function (e) {
        if (document.visibilityState === 'hidden') {
          _this3.showExitIntentPopup();
        }
      });

      this.timeouts.push(setTimeout(function () {
        console.log('exitOut');
        _this3.showExitIntentPopup();
      }, this.data.exitTime * 1000));

      this.ev.unregister(this.productAtc, 'click', this.addExitEventHandlers);
    }
  }, {
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.ev.unregisterAll();
      this.timeouts.forEach(function (timeout) {
        return clearTimeout(timeout);
      });
      this.io && this.io.disconnect();
    }
  }]);
  return StaticExitIntent;
}();

exports.default = StaticExitIntent;